import {
  Box,
  Collapse,
  debounce,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { useEffect, useMemo, useState } from "react";
import { useMutation } from "react-query";
import { clinicId } from "../../../constants";
import {
  getpatientProcedure,
  getpatientProcedureList,
  updateNursingProcedure,
} from "./service";
import { Cancel, Check, Remove, Edit, Done } from "@mui/icons-material";

import Checkbox from "@mui/material/Checkbox";
import React from "react";
import { useForm } from "react-hook-form";
import usePopup from "../../../hooks/usePopup";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import moment from "moment";
// import useAuthentication from "@hooks/useAuthentication";
// import dayjs from "dayjs";
const NursingProcedure = () => {
  const theme = useTheme();
  const { showSnackbar } = usePopup();
  const [expandedRow, setExpandedRow] = useState<number | null>(null);
  const [procedureList, setProcedureList] = useState<
    NursingProcedureType[] | null
  >(null);
  const [patientDetails, setPatientDetails] =
    useState<PatientDetailsType | null>(null);
  const {
    register,
    handleSubmit,
    formState: { isValid },
    control,
    setValue,
  } = useForm();
  const handleExpandClick = (index: number, item: PatientDetailsType) => {
    getProcedure(item.encounterId);
    setPatientDetails(item);
    setExpandedRow((prev) => (prev === index ? null : index));
  };
  const [searchfilter, setSearchfilter] = useState({
    clinicId: clinicId,
    filter: {
      search: "",
      searchDate: moment().format("YYYY-MM-DD"),
    },
    pageSize: 25,
    pageNumber: 0,
  });
  const handleChangePage = (_: any, newPage: number) => {
    setSearchfilter((prev: any) => ({
      ...prev,
      pageNumber: newPage,
    }));
  };
  const handleChangeRowsPerPage = (event: any) => {
    setSearchfilter((prev: any) => ({
      ...prev,
      pageSize: parseInt(event.target.value, 10),
      pageNumber: 0,
    }));
  };
  const {
    mutate: getList,
    data: patientList,
    isLoading: procedureLoading,
  } = useMutation(getpatientProcedureList);
  const { mutate: getProcedure } = useMutation(getpatientProcedure, {
    onSuccess: (data) => {
      const updatedData = data.map(
        (item: NursingProcedureType, index: number) => ({
          ...item,
          id: index,
          editMode: false,
        }),
      );
      setProcedureList(updatedData);
    },
  });
  const { mutate: updateProcedure } = useMutation(updateNursingProcedure, {
    onSuccess: (data: any) => {
      console.log(data);
      data.responseIndicator == "success" &&
        getProcedure(patientDetails?.encounterId as number);
      showSnackbar({
        message: "Nursing Procedure updated successfully",
        variant: "success",
        duration: 2000,
        open: true,
      });
    },
  });

  useEffect(() => {
    const currentDate = moment().format("YYYY-MM-DD"); // Formats as YYYY-MM-DD
    setValue("date", currentDate);
  }, []);

  useEffect(() => {
    getList(searchfilter);
  }, [searchfilter]);
  const onTextChange = (event: any) => {
    setSearchfilter((prev: any) => ({
      ...prev,
      filter: {
        ...prev.filter,
        search: event.target.value,
      },
    }));
  };
  const debounceSearch = useMemo(
    () => debounce(onTextChange, 300),
    [onTextChange],
  );
  const onsubmit = (
    data: any,
    item: NursingProcedureType,
    parentIndex: number,
  ) => {
    console.log("isPerformed", data.isPerformed);

    const body = {
      remarks: data[`remarks${parentIndex}${item.id}`],
      isPerformed: data.isPerformed[item.id as number],
      nursingProcedure: 1,
      encounterID: item.encounterId,
      procedureId: item.procedureId,
      clinicId,
    };
    updateProcedure(body);
  };
  //  const{user}= useAuthentication();
  //  const regionValue= user?.region;
  //    const idHeading =
  //   regionValue === "QATAR_REGION"
  //     ? "Qatar ID"
  //     : "Emirates Id";

  const idHeading = "Civil ID";

  const headings = [
    "SL No",
    "DATE",
    "EMR NO/REG NO",
    "Patient Name",
    idHeading,
    "Doctor",
  ];
  return (
    <Paper sx={{ margin: "10px", marginTop: "20px", borderRadius: 2 }}>
      <div className="grid grid-cols-12 gap-2 items-center justify-between p-5 border-b ">
        <Typography
          sx={(theme) => ({ color: theme.palette.primary.main })}
          className="col-span-5"
        >
          <strong>Procedure</strong>
        </Typography>
        <div className=" col-span-2 gap-x-2 ">
          <CustomFormField
            element="datepicker"
            name="date"
            control={control}
            fieldProps={{ label: "Search By Date" }}
            rules={{
              required: false,
              onChange: (e: any) => {
                setSearchfilter((prev: any) => ({
                  ...prev,
                  filter: {
                    ...prev.filter,
                    searchDate: moment(e.target.value).format("YYYY-MM-DD"),
                  },
                }));
              },
            }}
            dateFormat="DD-MM-YYYY"
          />
        </div>
        <div className="grid grid-cols-12 col-span-4 gap-x-2 ">
          <TextField
            onChange={(e: any) => {
              debounceSearch(e);
            }}
            className="col-span-12"
            fullWidth
            label=" Search by ID / Name"
            id="fullWidth"
          />
        </div>
      </div>
      <Table size="small">
        <TableHead
          sx={{ background: theme.palette.primary.main }}
          className="sticky top-0 border-2 "
        >
          <TableRow>
            {headings?.map((title, index) => (
              <TableCell
                key={index}
                sx={{ color: theme.palette.background.paper }}
              >
                {title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <CustomTableBody
          alert={"No records found"}
          isData={Boolean(patientList?.results?.length > 0)}
          totalSpan={{ row: 2, col: 7 }}
          dataLoading={procedureLoading}
        >
          {patientList?.results?.map(
            (item: PatientDetailsType, parentIndex: number) => (
              <React.Fragment key={item?.id || parentIndex}>
                <TableRow
                  className="cursor-pointer"
                  hover={true}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    cursor: "pointer",
                  }}
                >
                  <TableCell
                    onClick={() => handleExpandClick(parentIndex, item)}
                  >
                    {searchfilter.pageNumber * searchfilter.pageSize +
                      (parentIndex + 1)}
                  </TableCell>

                  <TableCell
                    onClick={() => handleExpandClick(parentIndex, item)}
                  >
                    {item.createdByDate}
                  </TableCell>
                  <TableCell
                    onClick={() => handleExpandClick(parentIndex, item)}
                  >
                    {item.patientId}
                  </TableCell>
                  <TableCell
                    onClick={() => handleExpandClick(parentIndex, item)}
                  >
                    {item.patientName}
                  </TableCell>
                  <TableCell
                    onClick={() => handleExpandClick(parentIndex, item)}
                  >
                    {item.emiratesId}
                  </TableCell>
                  <TableCell
                    onClick={() => handleExpandClick(parentIndex, item)}
                  >
                    {`${item.clinicianName}(${item.deptName})`}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={headings.length + 1}
                  >
                    <Collapse
                      in={expandedRow === parentIndex}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box margin={1}>
                        <Table
                          size="small"
                          sx={{
                            backgroundColor: theme.palette.background.paper,
                          }}
                        >
                          <TableHead>
                            <TableRow>
                              {heading2?.map((title, index) => (
                                <TableCell
                                  key={title + index}
                                  className="!font-black"
                                  sx={{ fontSize: "11px" }}
                                >
                                  {" "}
                                  {/* Unique key for each heading */}
                                  {title}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {procedureList?.map(
                              (item: NursingProcedureType, index: number) => (
                                <TableRow key={item.id || index}>
                                  {" "}
                                  {/* Use item.id or fallback to index */}
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{item.cptName}</TableCell>
                                  <TableCell>{item.quantity}</TableCell>
                                  <TableCell>
                                    {String(item.doctorsRemarks || "")}
                                  </TableCell>
                                  <TableCell>
                                    {item.editMode ? (
                                      <TextField
                                        {...register(
                                          `remarks${parentIndex}${index}`,
                                        )}
                                        label="Enter Remarks"
                                        variant="standard"
                                        defaultValue={item.remarks}
                                      />
                                    ) : (
                                      item.remarks
                                    )}
                                  </TableCell>
                                  <TableCell className="cursor-pointer">
                                    {item.editMode ? (
                                      <Checkbox
                                        {...register(`isPerformed.${index}`)}
                                        defaultChecked={
                                          item.isPerformed ? true : false
                                        }
                                      />
                                    ) : item.isPerformed ? (
                                      <Check color="success" />
                                    ) : (
                                      <Remove color="error" />
                                    )}
                                  </TableCell>
                                  <TableCell className="cursor-pointer">
                                    {!item.editMode && (
                                      <>
                                        <IconButton
                                          onClick={() => {
                                            if (item.id === index) {
                                              setProcedureList(
                                                (prevList: any) =>
                                                  prevList.map(
                                                    (
                                                      procedure: NursingProcedureType,
                                                      i: number,
                                                    ) =>
                                                      i === index
                                                        ? {
                                                            ...procedure,
                                                            editMode: true,
                                                          }
                                                        : procedure,
                                                  ),
                                              );
                                            }
                                          }}
                                        >
                                          <Edit color="primary" />
                                        </IconButton>
                                      </>
                                    )}
                                    {item.editMode && (
                                      <>
                                        <IconButton
                                          onClick={() => {
                                            if (item.id === index && isValid) {
                                              handleSubmit((data) =>
                                                onsubmit(
                                                  data,
                                                  item,
                                                  parentIndex,
                                                ),
                                              )();
                                              setProcedureList(
                                                (prevList: any) =>
                                                  prevList.map(
                                                    (
                                                      procedure: NursingProcedureType,
                                                      i: number,
                                                    ) =>
                                                      i === index
                                                        ? {
                                                            ...procedure,
                                                            editMode: false,
                                                          }
                                                        : procedure,
                                                  ),
                                              );
                                            }
                                          }}
                                        >
                                          <Done color="primary" />
                                        </IconButton>

                                        <IconButton
                                          onClick={() => {
                                            if (item.id === index) {
                                              setProcedureList(
                                                (prevList: any) =>
                                                  prevList.map(
                                                    (
                                                      procedure: NursingProcedureType,
                                                      i: number,
                                                    ) =>
                                                      i === index
                                                        ? {
                                                            ...procedure,
                                                            editMode: false,
                                                          }
                                                        : procedure,
                                                  ),
                                              );
                                            }
                                          }}
                                        >
                                          <Cancel color="error" />
                                        </IconButton>
                                      </>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ),
                            )}
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ),
          )}
        </CustomTableBody>

        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25]}
          count={patientList?.totalCount || 0}
          rowsPerPage={searchfilter.pageSize}
          page={searchfilter.pageNumber}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Table>
    </Paper>
  );
};
export default NursingProcedure;
// const headings = [
//   "SL No",
//   "DATE",
//   "EMR NO",
//   "Patient Name",
//   "Emirates Id",
//   "Doctor",
// ];

const heading2 = [
  "SL No",
  "Item",
  "Quantity",
  "Doctor Remarks",
  "Nursing Remarks",
  "IsPerformed",
  "Options",
];
